import React from 'react';

const INPUT_STYLE = {
  width: '100%',
  border: '1px solid #cbd5e1',
  borderRadius: '8px',
  padding: '9px 10px',
  fontSize: '13px',
  color: '#0f172a',
  background: 'white',
  fontFamily: 'inherit',
};

export default function TrialFilters({ filters, onChange, onClear, options }) {
  const set = (key, value) => onChange({ ...filters, [key]: value });

  return (
    <section style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '12px', marginBottom: '14px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <h3 style={{ margin: 0, fontSize: '14px', color: '#0f172a' }}>Filters</h3>
        <button type="button" onClick={onClear} style={{ border: 'none', background: 'transparent', color: 'var(--teal)', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}>
          Clear all
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '8px' }}>
        <label style={labelWrap}>
          Distance (km)
          <input type="number" min="1" value={filters.distance} onChange={(e) => set('distance', e.target.value)} style={INPUT_STYLE} placeholder="e.g. 100" />
        </label>

        <label style={labelWrap}>
          Cancer Type
          <select value={filters.cancerType} onChange={(e) => set('cancerType', e.target.value)} style={INPUT_STYLE}>
            <option value="">All</option>
            {options.cancerTypes.map((v) => <option key={v} value={v}>{v}</option>)}
          </select>
        </label>

        <label style={labelWrap}>
          Subtype
          <select value={filters.subtype} onChange={(e) => set('subtype', e.target.value)} style={INPUT_STYLE}>
            <option value="">All</option>
            {options.subtypes.map((v) => <option key={v} value={v}>{v}</option>)}
          </select>
        </label>

        <label style={labelWrap}>
          Stage
          <select value={filters.stage} onChange={(e) => set('stage', e.target.value)} style={INPUT_STYLE}>
            <option value="">All</option>
            {options.stages.map((v) => <option key={v} value={v}>{v}</option>)}
          </select>
        </label>

        <label style={labelWrap}>
          Biomarker
          <select value={filters.biomarker} onChange={(e) => set('biomarker', e.target.value)} style={INPUT_STYLE}>
            <option value="">All</option>
            {options.biomarkers.map((v) => <option key={v} value={v}>{v}</option>)}
          </select>
        </label>

        <label style={labelWrap}>
          Recruiting Status
          <select value={filters.recruitingStatus} onChange={(e) => set('recruitingStatus', e.target.value)} style={INPUT_STYLE}>
            <option value="">All</option>
            {options.statuses.map((v) => <option key={v} value={v}>{v}</option>)}
          </select>
        </label>

        <label style={labelWrap}>
          Trial Phase
          <select value={filters.phase} onChange={(e) => set('phase', e.target.value)} style={INPUT_STYLE}>
            <option value="">All</option>
            {options.phases.map((v) => <option key={v} value={v}>{v}</option>)}
          </select>
        </label>

        <label style={labelWrap}>
          Location
          <input type="text" value={filters.location} onChange={(e) => set('location', e.target.value)} style={INPUT_STYLE} placeholder="City, center, region" />
        </label>
      </div>

    </section>
  );
}

const labelWrap = {
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
  color: '#475569',
  fontSize: '12px',
  fontWeight: '600',
};
